import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useSnackbar } from "notistack";
import { CallFlowApi } from "service/api/call-flow.api";
import { QUERY_KEYS } from "service/constant/query-keys";

export const useGetListCallFlow = (params, options) => {
  return useQuery({
    queryKey: [QUERY_KEYS.CALL_FLOW_LIST, params],
    queryFn: async () => {
      const res = await CallFlowApi.getListCallFlow(params);
      return res.data;
    },
    ...options,
  });
};

export const useGetCallFlowDetail = (id, options) => {
  return useQuery({
    queryKey: [QUERY_KEYS.CALL_FLOW_DETAIL, id],
    queryFn: async () => {
      const res = await CallFlowApi.getCallFlowDetail(id);
      return res.data;
    },
    ...options,
  });
};

export const useGetCountListCallFlow = (params, options) => {
  return useQuery({
    queryKey: [QUERY_KEYS.CALL_FLOW_COUNT, params],
    queryFn: async () => {
      const res = await CallFlowApi.getCountListCallFlow(params);
      return res.data.count;
    },
    ...options,
  });
};

export const useCreateCallFlow = () => {
  const queryClient = useQueryClient();
  const { enqueueSnackbar } = useSnackbar();

  return useMutation({
    mutationFn: (payload) => {
      return CallFlowApi.createCallFlow(payload);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.CALL_FLOW_LIST] });
      enqueueSnackbar("Thêm luồng cuộc gọi thành công", { variant: "success" });
    },
  });
};

export const useEditCallFlow = (id) => {
  const queryClient = useQueryClient();
  const { enqueueSnackbar } = useSnackbar();

  return useMutation({
    mutationFn: (payload) => {
      return CallFlowApi.editCallFlow(id, payload);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.CALL_FLOW_LIST] });
      enqueueSnackbar("Chỉnh sửa luồng cuộc gọi thành công", {
        variant: "success",
      });
    },
  });
};

export const useUpdateStatusCallFlow = (id) => {
  const queryClient = useQueryClient();
  const { enqueueSnackbar } = useSnackbar();

  return useMutation({
    mutationFn: (payload) => {
      return CallFlowApi.updateStatusCallFlow(id, payload);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.CALL_FLOW_LIST] });
      enqueueSnackbar("Cập nhật trạng thái luồng cuộc gọi thành công", {
        variant: "success",
      });
    },
  });
};
